module.exports = __webpack_public_path__ + "static/halfling-male-AYAGWW-d56f8cb7004007dde0e68a33182a5bbd.png";